import { Box, Button, Fade, Grow, LinearProgress, makeStyles, Typography } from "@material-ui/core";
import CheckBoxOutlineBlankOutlinedIcon from "@material-ui/icons/CheckBoxOutlineBlankOutlined";
import CheckOutlinedIcon from "@material-ui/icons/CheckOutlined";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import { useState } from "react";
import { THEME_MODE } from "src/config/constants";

const useStyle = makeStyles((theme) => ({
  box: {
    backgroundColor: theme.palette.type === THEME_MODE.DARK ? "#233345" : "#F8F8F8",
    borderRadius: "10px",
    border: `1px solid ${theme.palette.type === THEME_MODE.DARK ? "#334965" : "#D8DFEB"}`,
  },
  button: {
    margin: "1rem 0rem 0.5rem 0rem",
  },
  icon: {
    fontSize: "14px",
    margin: "0.25rem 0.5rem 0rem 0rem",
    color: theme.palette.text.disabled,
  },
  normalText: {
    color: theme.palette.text.disabled,
    fontSize: "14px",
    fontWeight: 400,
  },
}));

export default function Analysis({ analysis, suggestions }) {
  const cls = useStyle();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button color="primary" variant="contained" onClick={() => setIsOpen(!isOpen)} className={cls.button}>
        Analysis
      </Button>
      {isOpen && (
        <Fade in={isOpen} timeout={1500}>
          {analysis && suggestions ? (
            <Box p={2} className={cls.box}>
              <Box mb={4}>
                <Typography color="secondary" variant="subtitle2">
                  Analysis
                </Typography>
                {analysis.map((element, index) => {
                  return (
                    <Grow key={index} in={true} timeout={1500} style={{ transitionDelay: `${index / 20 + 0.2}s` }}>
                      <Box display="flex" justifyContent="flex-start" alignItems="flex-start" mb={1}>
                        <CheckBoxOutlineBlankOutlinedIcon className={cls.icon} />
                        <Typography className={cls.normalText}>{element}</Typography>
                      </Box>
                    </Grow>
                  );
                })}
              </Box>
              <Box mb={5}>
                <Typography color="secondary" variant="subtitle2">
                  Suggestions
                </Typography>
                {suggestions.map((element, index) => {
                  return (
                    <Fade key={index} in={true} timeout={1500} style={{ transitionDelay: `${index / 18 + 1.1}s` }}>
                      <Box display="flex" justifyContent="flex-start" alignItems="flex-start" mb={1}>
                        <CheckOutlinedIcon className={cls.icon} />
                        <Typography className={cls.normalText}>{element}</Typography>
                      </Box>
                    </Fade>
                  );
                })}
              </Box>
              <Fade in={true} timeout={2000} style={{ transitionDelay: "1.35s" }}>
                <Box display="flex" justifyContent="flex-start" alignItems="flex-start">
                  <ReportProblemOutlinedIcon style={{ color: "#836FA9", marginRight: "0.5rem" }} />
                  <Typography className={cls.normalText} style={{ color: "#836FA9" }}>
                    We perform blockchain data analysis to evaluate the health of a token with our various indexes.
                    Based on that, we extract the token insights and recommend trading actions to you. The final
                    decision is up to you and we cannot be responsible if any problem arise!
                  </Typography>
                </Box>
              </Fade>
            </Box>
          ) : (
            <LinearProgress />
          )}
        </Fade>
      )}
    </>
  );
}
